import commandCenterPageConfig from './commandCenterPageConfig.reducer';

const reducer = {
  commandCenterPageConfig,
};

export default reducer;
